import api from 'services/api';
import { PraticalField } from './types';

const PREFIX = 'academico';

type SearchQueryParams = {
  search?: string;
};

type ListPraticalFieldRespose = {
  results: PraticalField[];
};

class PraticalFieldService {
  endpoint: string;

  constructor() {
    this.endpoint = 'pratical-field';
  }

  list = async (params: SearchQueryParams): Promise<ListPraticalFieldRespose[]> => {
    const response = await api.get(`${PREFIX}/${this.endpoint}`, {
      params,
    });

    return response.data;
  };

  get = async (id: number): Promise<PraticalField> => {
    const response = await api.get(`${PREFIX}/${this.endpoint}/${id}`);

    return response.data;
  };

  create = async (data: { name: string }): Promise<PraticalField> => {
    const response = await api.post(`${PREFIX}/${this.endpoint}`, data);

    return response.data;
  };

  update = async (
    id: number, data: Record<string, string>
  ): Promise<PraticalField> => {
    const response = await api.patch(`${PREFIX}/${this.endpoint}/${id}`, data);

    return response.data;
  };

  delete = async (id: number): Promise<null> => {
    const response = await api.delete(`${PREFIX}/${this.endpoint}/${id}`);

    return response.data;
  };
}

export default new PraticalFieldService();
